import { useEffect, useMemo } from 'react';
import { setup } from '@onemedical/command-palette';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { usePatientAutocompleteLazyQuery } from '../graphql/patient.generated';

const dobFormatter = new Intl.DateTimeFormat('en-US');

const chartUrl = process.env.REACT_APP_CLINICAL_UX_URL;

function CommandPalette() {
  // KBA-restricted users must use the navbar patient search, which grants
  // access before navigating. The command palette navigates directly and
  // cannot grant access, so the "Search for patients" action is not
  // registered for them (other palette commands remain available).
  const { omacsKbaEnabled } = useFlags();
  const [search, { data: results }] = usePatientAutocompleteLazyQuery();
  const addResultsToSearch = useMemo(() => {
    const { asyncActionBuilder } = setup({
      params: {
        adminUrl: '',
        onelifeUrl: process.env.REACT_APP_ONELIFE_URL!,
        templateUrl: process.env.REACT_APP_TEMPLATE_MANAGER_URL!,
      },
    });

    if (omacsKbaEnabled) {
      return null;
    }

    return asyncActionBuilder({
      action: {
        id: 'patients',
        title: 'Search for patients',
      },
      debounce: 200,
      async onSearch(query) {
        search({ variables: { textQuery: query } });
        return [];
      },
    });
  }, [search, omacsKbaEnabled]);

  useEffect(() => {
    if (!results?.patientSearch || !addResultsToSearch) {
      return;
    }
    addResultsToSearch(
      results.patientSearch.map((result) => {
        const { dob, label, id } = result;

        const dobString = dob ? ` (${dobFormatter.format(new Date(dob))})` : '';

        return {
          id: result.id.toString(),
          title: `${label}${dobString}`,
          url: `${chartUrl}/#/patients/${id}/chart/summaries/new`,
        };
      }),
    );
  }, [results, addResultsToSearch]);

  return null;
}

export default CommandPalette;
